/* @ts-ignore */
import UserAvatar from "react-user-avatar";
import "./NavbarTransparent.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Currency from "../Currency";
import Avatar from "../Avatar";
import LoginProc from "../../Auth/LoginProc";
import { GiHamburgerMenu } from "react-icons/gi";
import { useModal } from "../../Sliders/Modal/ModalContext";
import { useSelector } from "react-redux";
import { FaUser } from "react-icons/fa";

const LeftComp = () => {
  const navigate = useNavigate();
  return (
    <div className="flex items-center flex-1">
      <span
        className="font-bold text-2xl lg:text-3xl cursor-pointer text-white"
        onClick={() => navigate("/")}
      >
        Stavigo<span style={{ color: "#FF6A1A" }}>.</span>com
      </span>
    </div>
  );
};

const CenterNav = () => {
  const navigate = useNavigate();
  return (
    <nav className="hidden md:flex items-center gap-8">
      <span
        className="underline-animation cursor-pointer"
        style={{ fontWeight: 600, fontSize: 15 }}
        onClick={() => navigate("/flights")}
      >
        Flights
      </span>
      <span
        className="underline-animation cursor-pointer"
        style={{ fontWeight: 600, fontSize: 15 }}
        onClick={() => navigate("/interstate")}
      >
        Bus
      </span>
      {/* LagBus link hidden for now — the /lagbus route still resolves. */}
      <span
        className="underline-animation cursor-pointer"
        style={{ fontWeight: 600, fontSize: 15 }}
        onClick={() => navigate("/train")}
      >
        Train
      </span>
      <span
        className="underline-animation cursor-pointer"
        style={{ fontWeight: 600, fontSize: 15 }}
        onClick={() => navigate("/cowry")}
      >
        Cowry
      </span>
    </nav>
  );
};

const RightComp = ({ isOpen2, setIsOpen2, currency }: any) => {
  return (
    <div className="hidden md:flex gap-4 flex-1 justify-end items-center">
      <div className="hover:bg-[#3a3a3a40] hover:rounded px-2 flex justify-center items-center cursor-pointer">
        <span className="font-medium text-base">Help</span>
      </div>
      <div className="hover:bg-[#3a3a3a40] hover:rounded px-2 flex justify-center items-center cursor-pointer">
        <a
          className="no-underline text-white"
          href={
            currency && currency.country === "NG"
              ? "tel:+234 (201) 350-3000"
              : "tel:+1 (888) 665-3405"
          }
        >
          <span className="font-medium text-base">Support</span>
        </a>
      </div>
      <Currency />
      <Avatar isOpen={isOpen2} setIsOpen={setIsOpen2} />
    </div>
  );
};

const RightComp2 = ({ showModal, isAuth }: any) => {
  return (
    <div className="md:hidden flex space-x-2 justify-end items-center">
      {!isAuth && (
        <div onClick={() => showModal("authModal")}>
          <FaUser className="text-white hover:rounded px-2 text-4xl justify-center items-center cursor-pointer" />
        </div>
      )}
      <div
        onClick={() => showModal("settingModal")}
        className="text-white hover:rounded px-2 text-3xl justify-center items-center cursor-pointer"
      >
        <GiHamburgerMenu />
      </div>
    </div>
  );
};

const NavbarTransparent = () => {
  const [isOpen2, setIsOpen2] = useState(false);
  const { showModal } = useModal();
  const isAuth = useSelector((state: any) => state.client.isAuth);
  const currency = useSelector((state: any) => state.app.currency);

  return (
    <div className="absolute z-50 py-4 px-4 lg:px-8 w-full text-white">
      <LoginProc isOpen={isOpen2} setIsOpen={setIsOpen2} />
      <div className="flex w-full items-center">
        <LeftComp />
        <CenterNav />
        <RightComp
          isOpen2={isOpen2}
          setIsOpen2={setIsOpen2}
          currency={currency}
        />
        <RightComp2 showModal={showModal} isAuth={isAuth} />
      </div>
    </div>
  );
};

export default NavbarTransparent;
